import Image from "next/legacy/image"
import Link from "next/link"
import Block from "@/components/wrappers/block"
import Button from "@/common/button/button"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"
import styles from "./latest-products.module.css"

export default function LatestProducts({ block }) {
  const { attrs } = block

  const products = attrs.products.map((product, index) => {
    return (
      <div key={index} className={styles.card}>
        <div>
          <div className="p-4 mb-3 rounded-md w-17 h-17 sm:w-25 sm:h-25 bg-good-green-10">
            <figure className="relative w-full h-full">
              {product.icon && (
                <Image
                  src={product.icon}
                  layout="fill"
                  objectFit="contain"
                  objectPosition="center"
                />
              )}
            </figure>
          </div>
        </div>
        <div className="sm:pl-5">
          {product.tag.url && (
            <Link href={product.tag.url} prefetch={false}>
              <HeadingLabel>{product.tag.label}</HeadingLabel>
            </Link>
          )}
          {product.url && (
            <Link href={product.url} prefetch={false}>
              <h3 className="py-1 text-xl cursor-pointer">{product.heading}</h3>
            </Link>
          )}
          <span className="block text-sm">{product.licenseHolder}</span>
          <span className="block text-sm">{product.licenseDate}</span>
        </div>
      </div>
    )
  })

  return (
    <Block block={block}>
      <h2 className="mb-5 text-xl sm:text-1.5xl lg:leading-10 lg:text-2.5xl sm:mb-8 lg:mb-10">
        {attrs.heading}
      </h2>
      <div className="grid grid-cols-1 gap-5 sm:gap-10 md:grid-cols-2">
        {products}
      </div>
      <div className="text-center">
        <Button
          className="block mx-auto mt-8 sm:inline-block sm:mt-13"
          theme={attrs.button.theme}
          tagName={attrs.button.url ? "a" : ""}
          href={attrs.button.url}>
          {attrs.button.label}
        </Button>
      </div>
    </Block>
  )
}
